import { render, staticRenderFns } from "./HardwareInformationCard.vue?vue&type=template&id=cc245552&scoped=true"
import script from "./HardwareInformationCard.vue?vue&type=script&lang=ts"
export * from "./HardwareInformationCard.vue?vue&type=script&lang=ts"
import style0 from "./HardwareInformationCard.vue?vue&type=style&index=0&id=cc245552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_op2felhwcemqlmdmuodyzlbaea/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc245552",
  null
  
)

/* custom blocks */
import block0 from "./HardwareInformationCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports